var map = {
	"./contact/mapping": 753,
	"./cpo/mapping": 754,
	"./customer/mapping": 755,
	"./forwarderPo/mapping": 756,
	"./incomingInvoice/mapping": 757,
	"./incomingPayment/mapping": 758,
	"./outgoingInvoice/mapping": 759,
	"./outgoingPayment/mapping": 760,
	"./outgoingQuote/mapping": 761,
	"./product/mapping": 762,
	"./receiving/mapping": 763,
	"./shipping/mapping": 764,
	"./spo/mapping": 765,
	"./vendor/mapping": 766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 752;